// extracted by mini-css-extract-plugin
module.exports =  {"pageTitle":"pageTitle___4HJoG","publishTitle":"publishTitle___kExRo"};